import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

/** Tabs Navigation */
export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 32px 0 40px;
  margin: 0 auto;
`

export const TabItem = styled.button<{ isActive: boolean; width?: string }>`
  ${Typography.Body}
  ${FontWeights.Regular}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.Neutral90};
  border: 1px solid;
  border-color: ${Colors.Neutral15};
  border-radius: 32px;
  text-align: center;
  padding: 12px 16px;
  cursor: pointer;
  width: ${props => props.width || 'auto'};

  &:hover {
    background-color: ${Colors.Blue10};
    border-color: ${Colors.Blue10};
    color: ${Colors.Blue80};
  }

  & svg {
    flex: 1;
  }

  ${props =>
    props.isActive &&
    `
      background-color: ${Colors.Blue10};
      border-color: ${Colors.Blue30};
      color: ${Colors.Blue80};
      &:hover {
        border-color: ${Colors.Blue30}; 
      }
  `}
`

export const ConnectorLine = styled.div<{
  layout?: 'horizontal' | 'vertical'
  gradient?: 'top-to-bottom' | 'bottom-to-top' | 'left-to-right' | 'right-to-left'
}>`
  border-radius: 1px;
  transition: background-color 0.2s;

  ${({ layout = 'horizontal', gradient }) =>
    layout === 'vertical'
      ? `
    width: 3px;
    height: 16px;
    margin: 4px 0;
    background: ${
      gradient
        ? `
      linear-gradient(
        to ${gradient === 'top-to-bottom' ? 'bottom' : 'top'},
        ${Colors.Blue30} 0%,
        ${Colors.Blue10} 100%
      )`
        : Colors.Neutral15
    };
  `
      : `
    height: 3px;
    width: 28px;
    margin: 0 8px;
    background: ${
      gradient
        ? `
      linear-gradient(
        to ${gradient === 'left-to-right' ? 'right' : 'left'},
        ${Colors.Blue30} 0%,
        ${Colors.Blue10} 100%
      )`
        : Colors.Neutral15
    };
  `}
`
export const Dropdown = styled.select`
  appearance: none;
  border: 1px solid ${Colors.Blue30};
  background: ${Colors.Blue10};
  padding: 12px 16px;
  border-radius: 32px;
  color: ${Colors.Blue80};
`

export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`
